import { Grid, Image } from '@zillow/constellation';
import { Box, Card, Heading, Modal, Text, TextButton } from '@zillow/constellation-10';

import MediumIllustrationHouse1x from '../../../../../../images/MediumIllustrationHouse@1x.png';

import { AppSelectors } from '../../../../../../selectors';
import { useSelector } from '../../../../../../selectors/useSelector';

import type { ElementType } from 'react';

type FeatureCardProps = {
  heading: string;
  body: string;
  Icon: ElementType;
  modalContent: string;
  headingCount?: string | null;
};

const FeatureCard = ({ heading, body, Icon, modalContent, headingCount = null }: FeatureCardProps) => {
  const isDesktop = useSelector((state) => AppSelectors.makeIsScreenDesktop(state));

  const updatedHeading = headingCount ? `${headingCount} ${heading}` : heading;

  return (
    <>
      <Grid display="grid" gridColumnEnd={`span ${isDesktop ? 1 : 4}`} data-testid="FeatureCard">
        <Modal
          dividers={false}
          trigger={
            <Card outlined={false} interactive={true} elevated={true} tone="neutral">
              <Box css={{ display: 'flex', height: '100%', flexDirection: 'column' }}>
                <Box css={{ display: 'flex', justifyContent: 'space-between' }}>
                  <Text textStyle="body-bold" asChild>
                    <p>{updatedHeading}</p>
                  </Text>
                  <Icon size="sm" fontColor="brand" />
                </Box>
                <Box css={{ display: 'flex', flexGrow: 1 }}>
                  <Text asChild css={{ marginBlock: '200' }}>
                    <p>{body}</p>
                  </Text>
                </Box>
                <Box css={{ display: 'flex' }}>
                  <TextButton textStyle="body-sm">Learn more</TextButton>
                </Box>
              </Box>
            </Card>
          }
          body={
            <>
              <Box css={{ display: 'flex', justifyContent: 'center', marginBottom: '400' }}>
                <Image src={MediumIllustrationHouse1x} alt="house" />
              </Box>
              <Heading level={4} css={{ marginBottom: '400' }}>
                {heading}
              </Heading>
              <Text>{modalContent}</Text>
            </>
          }
        />
      </Grid>
    </>
  );
};

export { FeatureCard };
